import { mono, monoShared, monoForm } from '@components/systems/monolith/monolith.tokens'

/**
 * 로그인 전 3 페이지(Login · Membership · Reset password) 공용 스타일 — Monolith(2안).
 *
 * DESIGN_SYSTEM §6.4: 중앙 정렬 폼, 밑줄 입력, 블랙 CTA 하나. 카드·그림자·배경 사진 없음.
 * 페이지에서 css({ ...customerAuthStyle, ...페이지별 })
 */
export const customerAuthStyle = {
	...monoShared,
	...monoForm,
	position: 'relative' as const,
	width: '100%',

	'.mnAuthHeader': {
		display: 'flex',
		flexDirection: 'column' as const,
		alignItems: 'center',
		textAlign: 'center' as const,
		padding: 'clamp(64px, 8.3vw, 120px) 0 0',

		'.mnAuthTitle': {
			fontSize: 'clamp(44px, 6vw, 88px)',
			lineHeight: 1,
			fontWeight: 100,
			letterSpacing: '-0.01em',
			color: mono.ink,
		},
		'.mnAuthLede': {
			marginTop: 32,
			fontSize: 19,
			lineHeight: 1.6,
			fontWeight: 300,
			color: mono.dim,
			maxWidth: 460,
		},
	},

	'.mnAuthForm': {
		width: '100%',
		maxWidth: 480,
		margin: '0 auto',
		padding: 'clamp(56px, 6.25vw, 90px) 0 clamp(64px, 8.3vw, 120px)',
		display: 'flex',
		flexDirection: 'column' as const,
		gap: 36,
	},

	'.mnAuthAction': {
		display: 'flex',
		justifyContent: 'center',
		marginTop: 8,

		// 폭을 꽉 채우면 헤어라인 폼 위에서 블록 하나가 더 생긴다 — Contact 의 Send 처럼 인라인.
		'.mnAuthCta': {
			padding: '0 60px',
		},
	},

	'.mnAuthLinks': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: 20,

		'.mnAuthLink': {
			padding: 0,
			border: 0,
			background: 'transparent',
			fontSize: 13,
			fontWeight: 500,
			color: mono.dim,
			cursor: 'pointer',
			transition: 'color 200ms ease-out',

			'&:hover': {
				color: mono.ink,
			},
		},

		'.mnAuthLinkSep': {
			width: 1,
			height: 12,
			background: mono.lineSoft,
		},
	},

	'@media (prefers-reduced-motion: reduce)': {
		'.mnAuthLinks .mnAuthLink': {
			transition: 'none',
		},
	},
}
